<script>
    import { onMount } from "svelte";
    import { AuthUser } from "../../store.js";
    import wrappedFetch from "../../wrappedFetch.js";
    import { ProviderName, IsAuthConfigValid } from "./store.js";
    import Spinner from "../../routes/components/spinner.svelte";
    import WizardStep from "../../components/wizard/wizard-step.svelte";
    import WizardFinish from "../../components/wizard/wizard-finish.svelte";
    import Wizard from "../../components/wizard/wizard.svelte";
    import Router from "../../router.js";
    import Datasource from "./components/datasource.svelte";
    import Permissions from "./components/permissions.svelte";
    import Configuration from "./components/configuration.svelte";
    import Summary from "./components/summary.svelte";
    import FinalStep from "./components/finalstep.svelte";
    
    export let step = 0;
    export let msg = "";

    let clientId ="";
    let secret="";
    let simsPrimaryErrMsg="";
    let auCloudSubscribers;
    let estab=$AuthUser.establishment;
    let installKey="";
    const urlParams = new URLSearchParams(location.search);
    for (const [key, value] of urlParams) {
        if (`${key}` == "msg") msg = `${value}`;
    }    
    let errMsg = "";
    let attendanceScheduleError = "";
    let dataLoaded = false;
    let response;
    let optionsVM;
    let isCloud = false;
    let attendanceSchedules = [
        { strScheduleTime: "" },
        { strScheduleTime: "" },
    ];

    onMount(async () => {
        await getAllOptions();
        dataLoaded = true;
        // options = response.options;
    });
    const getAllOptions = async () => {
        dataLoaded = false;
        let resp = await wrappedFetch(`/api/import/GetAllOptions`, {
            method: "post",
        });
        response = await resp.json();
        optionsVM = response.optionsVM;
        isCloud = response.isCloud;
        // attendanceSchedule = response.attendanceSchedule;
        let providerName = response.providerName
            ? response.providerName.toLowerCase()
            : "";
        if (providerName == "") {
            dataLoaded = true;
            return;
        }
        //   if(providerName == "api") providerName = "bromcom";       
        ProviderName.set(providerName);
        if($ProviderName == "sims")        
            installKey = response.installKey;
      
        if($ProviderName == "simsprimary")
        {
            auCloudSubscribers = response.subscriber;
            clientId = auCloudSubscribers.clientId;
            secret = auCloudSubscribers.secret;
        }

        if (
            response.attendanceSchedule &&
            response.attendanceSchedule.length > 0
        )
            response.attendanceSchedule.forEach(
                (v, i) => (attendanceSchedules[i] = v)
            );
        if (!$IsAuthConfigValid) {
            let isAuthConfigValid = await wrappedFetch(
                `/api/import/IsAuthConfigValid?providerName=${$ProviderName.toUpperCase()}`,
                {
                    method: "post",
                }
            )
                .then((resp) => resp.text())
                .then((result) => {
                    return result;
                });              
            IsAuthConfigValid.set(isAuthConfigValid);
        }
        dataLoaded = true;
      
    };

    const validateOnSubmit = () => {
        errMsg = "";
        attendanceScheduleError = "";
        let isIncomplete =
            optionsVM.importStaff == null ||
            (optionsVM.showContacts && optionsVM.importContacts == null) ||
            (optionsVM.showGroups &&
                optionsVM.importGroupsAndClasses == null) ||
            (optionsVM.showAttendance && optionsVM.importAttendance == null);

        if (
            optionsVM.importStudents == null ||
            (optionsVM.importStudents == 0 && optionsVM.importStaff == null) ||
            (optionsVM.importStudents == 1 && isIncomplete)
        ) {
            errMsg = "Please answer all the options.";
            return;
        }
        if (optionsVM.importStudents == 0 && optionsVM.importStaff == 0) {
            errMsg = "Please select 'Yes' to at least one options.";
            return;
        }

        if (
            optionsVM.importAttendance == 1 &&
            optionsVM.showAttendanceSchedule &&
            !attendanceSchedules.some((a) => a.strScheduleTime != "")
        ) {
            attendanceScheduleError = "Please add at least one attendance schedule.";
            return;
        }
        if (errMsg == "" && attendanceScheduleError == "") return true;
    };
    const saveSettings = async () => {
        if (attendanceSchedules.length > 0)
            attendanceSchedules.forEach(
                (schedule) =>
                    (schedule.stringScheduleTime = schedule.strScheduleTime)
            );
        let optionsList = {
            attendanceSchedule: attendanceSchedules,
            optionsVM: optionsVM,
        };

        let resp = await wrappedFetch(`/api/import/SaveOptions`, {
            method: "post",
            body: JSON.stringify(optionsList),
            headers: {
                "Content-Type": "application/json",
            },
        });
        let response = await resp.json();
        optionsVM = response.optionsVM;
        if (optionsVM.showAttendanceSchedule) {
            response.attendanceSchedule.forEach(
                (v, i) => (attendanceSchedules[i] = v)
            );
            attendanceSchedules.forEach((schedule) => {
                if (schedule.stringScheduleTime != null)
                    schedule.strScheduleTime = schedule.stringScheduleTime;
            });
        }
    };
    const authenticateSims = async () => {
        if (clientId == "" || secret == "") {
            simsPrimaryErrMsg = "Both fields are required";
            return false;
        }
        let resp = await wrappedFetch(
            `/api/import/AuthenticateSimsPrimary?clientId=${clientId}&secret=${secret}`,
            {
                method: "post",
            }
        );
        let result = await resp.json();
        IsAuthConfigValid.set(result.success);
        if (result.success) simsPrimaryErrMsg = "";
        else
        simsPrimaryErrMsg=result.message;
        return result.success;
    };
</script>
{#if !dataLoaded}
<Spinner/>
{:else}
    {#if step == 'summary'}
        <Summary bind:optionsVM bind:attendanceSchedules isCloud={isCloud} bind:installKey bind:estab/>
    {:else}
        <Wizard
            startingStep={step}
            onValidate={async (step) => {
                
                errMsg = '';
                if ($ProviderName == '') return false;
                if (step == 'step1' && $ProviderName != '') {
                    return true;
                }
                if (step == 'step2') {
                    if($ProviderName =="simsprimary")
                       return await authenticateSims();
                   if($IsAuthConfigValid == 1)
                    return true;
                }
                if (step == 'step3') return validateOnSubmit();

                return false;
            }}
            onBeforeNavigating={(currentStep, nextStep) => {
                Router.route(`/app/import/${nextStep}`, false);
                return true;
            }}
            onSubmit={async () => {
                await saveSettings();
                // Router.route(`/import/summary`, false);
            }}>
            <WizardStep
                key="step1"
                title="Select MIS"
                icon="fas fa-hand-pointer"
                showNextButton={$ProviderName != ''}>
                <Datasource
                    on:misSelected={async () => await getAllOptions()} />
            </WizardStep>
            <WizardStep key="step2" title="Setup" icon="fas fa-sign-in-alt">
            <Permissions bind:clientId bind:secret bind:simsPrimaryErrMsg bind:installKey bind:estab/>
            </WizardStep>
            <WizardStep key="step3" title="Configuration" icon="fa fa-cog">
                <Configuration
                    bind:optionsVM
                    bind:attendanceSchedules
                    bind:errMsg
                    bind:attendanceScheduleError />
            </WizardStep>
            <WizardFinish>
                <FinalStep />
            </WizardFinish>
        </Wizard>
    {/if}
{/if}
